import { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, Navigation, EffectFade } from "swiper/modules";
import "swiper/css";
import "swiper/css/effect-fade";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { SlArrowRight, SlArrowLeft } from "react-icons/sl";
import { getSlider } from "../api/api";

function HeroSlider() {
  const [slides, setSlides] = useState([]);
  const [loading, setLoading] = useState(true);
  const slideUrl = "https://cricketapi.sindoor7.com/";

  useEffect(() => {
    getSlider()
      .then((response) => {
        setSlides(response.data.data); // Correct nested data access
        setLoading(false);
      })
      .catch((error) => {
        console.error("Failed to fetch slides:", error);
        setLoading(false);
      });
  }, []);

  if (loading) {
    return (
      <section className="hero-slider">
        <p>Loading slides...</p>
      </section>
    );
  }

  if (!slides.length) {
    return (
      <section className="hero-slider">
        <p>No slides available.</p>
      </section>
    );
  }

  return (
    <section className="hero-slider">
      <Swiper
        modules={[Autoplay, Pagination, Navigation, EffectFade]}
        effect="fade"
        autoplay={{ delay: 5000, disableOnInteraction: false }}
        pagination={{ clickable: true, dynamicBullets: true }}
        navigation={{ nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev" }}
        loop={true}
        speed={1000}
        className="hero-swiper"
      >
        {slides.map((slide) => (
          <SwiperSlide key={slide._id}>
            <div className="hero-slide">
              <div className="hero-bg">
                <img
                  src={`${slideUrl}${slide.image}`}
                  alt={slide.title}
                  className="hero-image"
                />
                <div className="hero-overlay"></div>
              </div>
              <div className="hero-content">
                <div className="container">
                  <div className="hero-text-wrapper">
                    <h1 className="hero-title animate-title">{slide.title}</h1>
                    <p className="hero-subtitle animate-subtitle">{slide.description}</p>
                    {/* You can add buttonText and buttonLink if your API provides them */}
                  </div>
                </div>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>

      {/* Custom Navigation Buttons */}
      <div className="swiper-button-prev custom-nav">
        <SlArrowLeft />
      </div>
      <div className="swiper-button-next custom-nav">
        <SlArrowRight />
      </div>
    </section>
  );
}

export default HeroSlider;